import { area, curveBasis } from 'd3-shape';
import { findKey } from 'lodash';
import { max } from 'd3-array';
import { select } from 'd3-selection';
import React, { Component } from 'react';

import PropTypes from 'prop-types';

import Stream from './stream';
import * as chartUtils from '../../../utils/chart-utils';
import styles from './stream-graph-chart.module.scss';

class StreamGraphChart extends Component{
    constructor( props ){
        super( props );
        const {
            data,
            layer,
            scales: { xScale, yScale },
            xKey
        } = this.props;

        this.state = {
            streamGraphProps: {
                data,
                keys: { x: xKey, },
                layer,
                xScale,
                yScale,
            }
        };
    }

    componentDidMount(){
        this.displayMaxVolumeMarker();
    }

    componentDidUpdate(){
        this.displayMaxVolumeMarker();
    }

    displayMaxVolumeMarker = () => {
        const { data, interval, scales } = this.props;
        const maxCount = max( data, d => +d['total'] );
        const index = parseInt( findKey( data, { total: maxCount } ) );
        const maxVolume = data[index];

        if( maxVolume ){
            let rightTextOverflow;
            const { date } = maxVolume;
            const datePosition = scales.xScale()( date );
            const totalInHalf = maxVolume.total / 2 ;
            const upperLineBoundary = scales.yScale()( totalInHalf );
            const lowerLineBoundary = scales.yScale()( -totalInHalf );
            const xOffset = chartUtils.getXOffsetForMaxVolumeText( maxCount );

            const initialTextPosition = datePosition + xOffset;
            if( datePosition > 650 ){
                rightTextOverflow = datePosition - xOffset;
            }
            const textOffset = rightTextOverflow ? rightTextOverflow : initialTextPosition;

            const stream = area()
                .x( d => scales.xScale()( d.data['date'] ) )
                .y0( d => scales.yScale()( d[0] - 1 ) )
                .y1( d => scales.yScale()( d[1] + 1 ) )
                .curve( curveBasis );

            this.addMaxVolumeLine( datePosition, lowerLineBoundary, upperLineBoundary, stream );
            const formattedDate = chartUtils.getTimeFormat( data, date, index, interval );
            this.addMaxVolumeText( textOffset, maxCount, formattedDate );
        }
    }

    addMaxVolumeText = ( textOffset, maxCount, formattedDate ) => {
        const { height } = this.props;
        select( this.maxVolume )
            .append( 'text' )
            .attr( 'x', textOffset )
            .attr( 'y', height + 4 )
            .attr( 'class', styles.maxVolumeText )
            .text(  maxCount.toLocaleString() + ' outbound emails, ' + formattedDate );
    }

    addMaxVolumeLine = ( datePosition, lowerLineBoundary, upperLineBoundary, stream ) => {
        const { yKey, layer } = this.props;
        const clipPath =  select( this.maxVolume )
            .append( 'clipPath' )
            .attr( 'id','areaToClip' + yKey );

        clipPath.selectAll( 'path' )
            .data( layer() )
            .enter()
            .append( 'path' )
            .attr( 'd', stream );

        select( this.maxVolume )
            .append( 'line' )
            .attr( 'clip-path',`url(#areaToClip${yKey})` )
            .attr( 'x1', datePosition )
            .attr( 'x2', datePosition )
            .attr( 'y1', upperLineBoundary )
            .attr( 'y2', lowerLineBoundary )
            .attr( 'class', styles.maxVolumeLine );
    }

    render(){
        const { streamGraphProps } = this.state;
        const { topOffset } = this.props;

        return (
            <g className={styles.streamGraph} transform={`translate(0 ${topOffset})`}>
                <Stream {...streamGraphProps} styles={styles}/>
                <g className={styles.maxVolumeIndicator} ref={el => this.maxVolume = el} ></g>
            </g>
        );
    }
};

StreamGraphChart.defaultProps = {
    data: []
};

StreamGraphChart.propTypes = {
    data: PropTypes.array,
    height: PropTypes.number,
    interval: PropTypes.string,
    layer: PropTypes.func,
    scales: PropTypes.shape( {
        xScale: PropTypes.func,
        yScale: PropTypes.func
    } ),
    topOffset: PropTypes.number,
    width: PropTypes.number,
    xKey: PropTypes.string.isRequired,
    yKey: PropTypes.string.isRequired,
};

export default StreamGraphChart;
